<h1 mat-dialog-title><i class="fad fa-question-circle"></i>&nbsp;&nbsp; Tem Certeza?</h1>
<div mat-dialog-content class="border-top border-bottom pt-4 pb-3 text-center">

  <p>{{ message }}</p>

</div>
<div mat-dialog-actions class="text-center">
    <div class="container-fluid px-0 py-3 justify-content-between">
      <button class="btn btn-light text-danger mx-2" (click)="dialogRef.close(false)">
        <i class="fa fa-times mr-3"></i>Cancelar
      </button>
      <button class="btn btn-light text-success mx-2" (click)="dialogRef.close(true)">
        <i class="fa fa-check mr-3"></i>Confirmar
      </button>
    </div>
</div>
